import type { FC } from 'react';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/basicActions';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { illustrationUrl } from '../../StudioBlankSlate';
import BasicBlankSlate from '../../_partials/BasicBlankSlate';

const JOURNALS_IMG_URL = illustrationUrl('studio-journals-empty.png', 2);

const JournalsBlankSlate: FC<{}> = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const onClick = useCallback(() => {
    dispatch(
      pushModal(ModalType.JOURNAL, {
        wrapInModal: false,
        params: {},
      })
    );
  }, [dispatch]);

  return (
    <BasicBlankSlate
      illustrationSrc={JOURNALS_IMG_URL}
      title={t('studio.blankSlate.journals.title')}
      message={t('studio.blankSlate.journals.message')}
      ctaLabel={t('studio.blankSlate.journals.cta')}
      ctaOnClick={onClick}
    />
  );
};
JournalsBlankSlate.displayName = 'JournalsBlankSlate';

export default JournalsBlankSlate;
